/* eslint-disable react-hooks/exhaustive-deps */
import React, { useState, useEffect, useContext, useRef } from "react";
import { useNavigate } from "react-router-dom";
import { ToastContainer } from "react-toastify";
import "./Invoice.css";
import { useLocation } from "react-router-dom";
import useApi from "../../../../../utils/api-manager/Helper/useApi";
import AuthContext from "../../../../../utils/secure-route/AuthContext";
import ATMDepositTable from "./ATMDepositTable";
import { useToastHandler } from "../../../../common/ToastHandler";
function AtmDeposit() {
  const { user } = useContext(AuthContext);
  const { Post  , _Get } = useApi();
  const storeid = user.store;
  const navigate = useNavigate();
  const today = new Date().toISOString().split("T")[0]; 
  const [activeButton, setActiveButton] = useState("");
  const location = useLocation();
  const {handleToast} = useToastHandler()
  useEffect(() => {
    setActiveButton(location.pathname); 
  }, [location.pathname]);

  const [, setIsOpen] = useState(false);
  const [, setBanks] = useState([]);

  const dropdownRef = useRef(null);

  const [reloadData, setReloadData] = useState(false);
  const [formData, setFormData] = useState({
    date: "" || today,
    transaction_type: "ATM Deposit",
    bank: "",
    amount: "",
    cash_amount: "",
    cheque_amount: "",
    total_amount: "",
    note: "",
    atm_commission: "",
    income_type: null,
    bank_deposite_type: "",
    owner: null,
  });

  const makeBlank = () => {
    setFormData({
      date: "" || today,
      transaction_type: "ATM Deposit",
      bank: "",
      amount: "",
      cash_amount: "",
      cheque_amount: "",
      total_amount: "",
      note: "",
      atm_commission: "",
      income_type: null,
      bank_deposite_type: "",
      owner: null,
    });
  };

  const handleCancel = () => {
    makeBlank();
  };

  useEffect(() => {
    const fetchBanks = async () => {
      try {
        const data = await _Get("bank");
        setBanks(data);
      } catch (error) {
        console.error("Error fetching banks:", error);
      }
    };
    fetchBanks();
  }, []);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    document.addEventListener("click", handleClickOutside);

    return () => {
      document.removeEventListener("click", handleClickOutside);
    };
  }, []);

  const handleLinkClick = (path) => {
    setIsOpen(false); 
    navigate(path); 
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!formData.bank_deposite_type || formData.bank_deposite_type === "") {
      // toast.error("Please select a valid Deposite type."); 
      handleToast({
        type:"ERROR",
        message:'Please select a valid Deposite type.'
      })
      return; 
    }

    if (!formData.cash_amount || formData.cash_amount <= 0) {
      // toast.error("Please enter a valid Cash amount."); 
      handleToast({
        type:"ERROR",
        message:'Please enter a valid Cash amount.'
      })
      return; 
    }

    try {
      const updatedFormData = { ...formData, store: storeid };
      await Post("transactionData", updatedFormData)
        .then((resp) => {
          // toast.success("Submission successful!");
          handleToast({
            type:"SUCCESS",
            message:'Submission successful!'
          })
          setReloadData(!reloadData);

          makeBlank();
        })
        .catch((error) => {
          setReloadData(!reloadData);
          console.error("Error submitting form:", error);
          // toast.error("Submission failed: " + error.message);
          handleToast({
            type: "ERROR",
            message: `Submission failed: ${error.message}`
          });
          
        });
    } catch (error) {
      setReloadData(!reloadData);
      // toast.error("Submission failed: " + error.message);
      handleToast({
        type: "ERROR",
        message: `Submission failed: ${error.message}`
      });
    }
  };

  return (
    <div className="dashboard-container">
      <ToastContainer />
      {/* <div className="d-flex justify-content-between mb-4">
        <div className="button-groups">
          <button
            className={`btn ${activeButton === "/" ? "active" : ""}`}
            onClick={() => handleLinkClick("/")}
          >
           Quick Invoice
          </button>
          <button
            className={`btn ${
              activeButton === "/quick-invoice" ? "active" : ""
            }`}
            onClick={() => handleLinkClick("/quick-invoice")}
          >
            Retail Invoice
          </button>
          <button
            className={`btn ${
              activeButton === "/salesInvoice" ? "active" : ""
            }`}
            onClick={() => handleLinkClick("/salesInvoice")}
          >
            Wholesale Invoice
          </button>
          <button
            className={`btn ${activeButton === "/addInvoice" ? "active" : ""}`}
            onClick={() => handleLinkClick("/addInvoice")}
          >
            Add Bill/Invoice
          </button>
          <button
            className={`btn ${activeButton === "/payInvoice" ? "active" : ""}`}
            onClick={() => handleLinkClick("/payInvoice")}
          >
            Pay Bill/Invoice
          </button>

          <button
            className={`btn ${activeButton === "/atmDeposit" ? "active" : ""}`}
            onClick={() => handleLinkClick("/atmDeposit")}
          >
            ATM Deposit
          </button>

          <button
            className={`btn ${activeButton === "/bankDeposit" ? "active" : ""}`}
            onClick={() => handleLinkClick("/bankDeposit")}
          >
            Bank Deposit
          </button>
        </div>
      </div> */}
      <div className="">
        <div
          className="responsive-box"
          style={{
            backgroundColor: "white",
            border: "1px solid #EBEAF2",
            boxShadow: "0px 2px 8px rgba(6, 12, 34, 0.0392157)",
            borderRadius: "40px",
          }}
        >
          <form onSubmit={handleSubmit}>
            <div
              className=" col-md-12 row mb-3"
              style={{
                gap: "11%",
                marginLeft: "20px",

              }}
            >
              <div className="col-md-3 mb-2">
                <input
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none", 
                    borderBottom: "1px solid #ccc", 
                    borderRadius: "0px", 
                    height: "52px",
                  }}
                  type="date"
                  className="form-control-borderless"
                  name="date"
                  value={formData.date || today}
                  onChange={handleChange}
                  required
                />
              </div>
              <div className="col-md-3 mb-3">
                <select
                  style={{
                    backgroundColor: "#ffffff",
                    border: "none", 
                    borderBottom: "1px solid #ccc", 
                    borderRadius: "0px", 
                    height: "52px",
                  }}
                  className="input-select"
                  id="bank_deposite_type"
                  name="bank_deposite_type"
                  value={formData.bank_deposite_type}
                  onChange={handleChange}
                >
                  <option value="">Select Cash type</option>
                  {["Business cash", "Lottery cash", "Gas cash"].map((type) => (
                    <option key={type} value={type}>
                      {type}
                    </option>
                  ))}
                </select>
              </div>
              <div className="col-md-3 mb-4">
                <div
                  className="input-group"
                  style={{ position: "relative", width: "100%" ,marginTop: "19px"}}
                >

                  <input
                    id="cash_amount"
                    type="number"

                    className="form-control-invoice"
                    name="cash_amount"
                    placeholder=" " 
                    value={formData.cash_amount}
                    onChange={handleChange}
                    onInput={(e) => {
                      e.target.value = e.target.value
                        .replace(/[^0-9.]/g, "") 
                        .replace(/^(\d*\.?\d{0,2}).*/g, "$1") 
                        .slice(0, 12); 
                    }}
                  />
                     <label
                    htmlFor="cash_amount"
                     className="floating-label-invoice"

                  >
                    Amount
                  </label>
                </div>
              </div>

              {}
            </div>

            <div className="col-md-3 row">
              {}
            </div>

            <div className="">
              <div
                className="d-flex justify-content-end"
                style={{ gap: "15px" }}
              >
                <button
                  type="button"
                  className="btn btn-contained me-2"
                  onClick={handleCancel}
                  style={{
                    border: " 1px solid #282e26",
                    borderRadius: "20px",
                    width: "150px",
                    height: "38px",
                    fontWeight: "bold",
                  }}
                >
                  Clear
                </button>
                <button
                  type="submit"
                  className="btn"
                  style={{
                    color: "white",
                    backgroundColor: "#282e26",
                    borderRadius: "40px",
                    width: "150px",
                    height: "38px",
                    fontWeight: "bold",
                  }}
                >
                  Save
                </button>
              </div>
            </div>
          </form>
        </div>
      </div>
      <div
        className="responsive-box"
        style={{
          backgroundColor: "white",
          boxShadow: "0px 2px 8px rgba(6, 12, 34, 0.0392157)",
          border: "1px solid #EBEAF2",
        }}
      >
        <ATMDepositTable
          transaction_type="ATM Deposit"
          reloadData={reloadData}
        />
      </div>
    </div>
  );
}

export default AtmDeposit;